import { ActionTree } from "vuex";
import { HttpClient } from "@/service/httpClient";
import { UserState, RootState, StandRes } from "@/interface";
import { refreshTokenAction } from "./action-types";
import { updateUserInfo } from "./mutation-types";

export const actions: ActionTree<UserState, RootState> = {
  [refreshTokenAction]: ({ commit }) => {
    return HttpClient.get<StandRes<string>>("/iam/refreshToken").then(
      ({ data }) => {
        const object = parseToken(data.message);
        HttpClient.setCSRFToken(object.non);
        const oSearchParams = new URLSearchParams(window.location.search);
        return commit(updateUserInfo, {
          ...object,
          invitationCode: oSearchParams.get("code")
        });
      }
    );
  }
};

const parseToken = (token: string) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c: string) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
};
